import { Box } from "@mui/material";
import Image from "next/image";

type Props = {
  src: string;
  alt: string;
  height?: number;
  label?: string;
};

export const FamentoImageCard = ({ src, alt, height = 600, label }: Props) => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 3,
      }}
    >
      <Image
        src={src}
        alt={alt}
        width={600}
        height={height}
        style={{
          width: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />

      {label && (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: "white",
            color: "primary.main",
            fontSize: 10,
            fontWeight: 600,
            px: 1,
            py: 0.5,
            borderRadius: 1,
          }}
        >
          {label}
        </Box>
      )}
    </Box>
  );
};
